// @flow
import { Colors } from '@zapier/theme';

const Styles = {
  root: {
    backgroundColor: Colors.white,
    position: 'relative',
    borderBottom: `1px solid ${Colors.storm}`,
  },

  heading: (isLight: boolean, backgroundImage: string) => ({
    padding: '100px 0 550px',
    height: '100%',
    textAlign: 'center',
    marginBottom: 75,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    color: isLight ? Colors.white : Colors.batmobile,
  }),

  headerText: {
    margin: 0,
    padding: 20,
    fontSize: 20,
  },

  helpHeading: {
    margin: 0,
    padding: 0,
    letterSpacing: 0,
    color: Colors.deepSpace,
    textAlign: 'center',
    marginBottom: '1em',
    fontSize: '3rem',
    fontWeight: 600,
  },

  searchButton: {
    position: 'absolute',
    left: 16,
    top: 5,
    paddingTop: 0,
    width: 17,
  },

  searchWrapper: {
    margin: '0 auto',
    padding: '0 15px',
    maxWidth: '600px',
  },

  actionWrapper: {
    padding: '55px 25px',
  },

  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },

  actionImage: {
    maxWidth: 200,
  },

  actionTitle: {
    marginBottom: 5,
  },

  arrowRight: {
    position: 'relative',
    top: 2,
    marginLeft: 5,
  },

  errorCode: {
    fontSize: 35,
    fontWeight: 600,
    margin: 0,
  },
};

export default Styles;
